import { GoogleAds } from '@sgcmpteltd/uikit-next';
import type {
  OnSlotRenderEnded,
} from '@sgcmpteltd/uikit-next/components/google-ads';
import dayjs from 'dayjs';
import { useSearchParams } from 'next/navigation';
import { useEffect, useMemo, useRef } from 'react';

import { TextLink } from '@/components/text-link';
import {
  newCarCompetitorPromotion as newCarCompetitorPromotionGoogleAdsConfig,
  newCarPromotion as newCarPromotionGoogleAdsConfig,
} from '@/configs/google/ads/desktop';
import {
  mobileNewCarCompetitorPromo as newCarMobileCompetitorPromotionGoogleAdsConfig,
  mobileNewCarPromo as newCarMobilePromotionGoogleAdsConfig,
} from '@/configs/google/ads/mobile';
import { joinSgcmSite } from '@/utils/url/join/public';

import {
  GOOGLE_ADS_TARGETING_KEY_NEW_CAR_COMPETITOR,
  GOOGLE_ADS_TARGETING_KEY_NEW_CAR_PROMOTION,
  PROMO_TYPE_NORMAL,
  PROMOTION_POSTED_ON_DATE_FORMAT,
} from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const TacticalAds: Component = ({
  item,
}) => {
  const searchParqams = useSearchParams();
  const competitorCar = searchParqams.get('competitor_car');
  const onSlotRenderEndedRef = useRef<OnSlotRenderEnded>(({
    isEmpty,
    slot,
  }) => {
    if (!isEmpty) {
      return;
    }

    window.googletag.cmd.push(() => {
      window.googletag.pubads().refresh([
        slot,
      ]);
    });
  });

  const targetingMap = useMemo(() => {
    const result: Record<string, string | string[]> = {
      [GOOGLE_ADS_TARGETING_KEY_NEW_CAR_PROMOTION]: [
        `${item?.id}`,
      ],
    };

    if (competitorCar) {
      result[
        GOOGLE_ADS_TARGETING_KEY_NEW_CAR_COMPETITOR
      ] = competitorCar.split(',');
    }

    return result;
  }, [competitorCar, item?.id]);

  useEffect(() => {
    const adContainer = document
      .querySelector(`#${newCarMobilePromotionGoogleAdsConfig.divId}`) as HTMLElement;
    const adCompetitorContainer = document
      .querySelector(`#${newCarMobileCompetitorPromotionGoogleAdsConfig.divId}`) as HTMLElement;

    if (adContainer) {
      adContainer.style.width = '300px';
    }

    if (adCompetitorContainer) {
      adCompetitorContainer.style.width = '300px';
    }
  }, []);

  return (
    <div className={styles.adPromoContentContainer}>
      <div className={styles.containerPromotionContent}>
        <div className={styles.containerPromotionTitleContent}>
          <div className={styles.containerTitleContentDetail}>
            <div
              className={styles.containerGoogleAds}>
              <GoogleAds
                adUnitPath={
                  competitorCar
                    ? newCarCompetitorPromotionGoogleAdsConfig.adUnitPath
                    : newCarPromotionGoogleAdsConfig.adUnitPath
                }
                divId={
                  competitorCar
                    ? newCarCompetitorPromotionGoogleAdsConfig.divId
                    : newCarPromotionGoogleAdsConfig.divId
                }
                slot={
                  competitorCar
                    ? newCarCompetitorPromotionGoogleAdsConfig.slot
                    : newCarPromotionGoogleAdsConfig.slot
                }
                targetingMap={targetingMap}
                onSlotRenderEndedRef={onSlotRenderEndedRef} />
            </div>
            <div
              className={styles.containerGoogleMobileAds}>
              <GoogleAds
                adUnitPath={
                  competitorCar
                    ? newCarMobileCompetitorPromotionGoogleAdsConfig.adUnitPath
                    : newCarMobilePromotionGoogleAdsConfig.adUnitPath
                }
                divId={
                  competitorCar
                    ? newCarMobileCompetitorPromotionGoogleAdsConfig.divId
                    : newCarMobilePromotionGoogleAdsConfig.divId
                }
                slot={
                  competitorCar
                    ? newCarMobileCompetitorPromotionGoogleAdsConfig.slot
                    : newCarMobilePromotionGoogleAdsConfig.slot
                }
                targetingMap={targetingMap}
                onSlotRenderEndedRef={onSlotRenderEndedRef} />
            </div>
            <div className={styles.containerApplicable}>
              { item?.isAllModels
                ? (
                  <ul
                    className={styles.listPromotionModelLink}>
                    <li
                      key="all models"
                      className={styles.linkPromotionModel}>
                      <TextLink
                        href={`${joinSgcmSite(`/new_cars/newcars_listing.php?DID=${item.dealer.id}`)}`}
                        target="_self"
                        text={`All ${item.make} Models`} />
                    </li>
                  </ul>
                )
                : (
                  <ul
                    className={styles.listPromotionModelLink}>
                    {
                      item?.models.map(({ title, link: modelLink }) => (
                        <li
                          key={modelLink}
                          className={styles.linkPromotionModel}>
                          <TextLink
                            href={modelLink}
                            text={title} />
                        </li>
                      ))
                    }
                  </ul>
                )}

            </div>
            <div
              className={styles.containerPromotionDate}>
              <div className={styles.textRed}>
                {item?.endsOn}
              </div>
              <div className={styles.textGray}>
                Posted on:
                {' '}
                <time>
                  {dayjs(item?.postedOn)
                    .format(PROMOTION_POSTED_ON_DATE_FORMAT)}
                </time>
              </div>
            </div>
          </div>
        </div>
      </div>
      { item?.promoType === PROMO_TYPE_NORMAL && (
        <div>is normal ads</div>
      ) }
    </div>
  );
};
